import {
  BlendRatioContainer,
  BlendRatioItem,
  BlendRatioItems,
} from '../SavedBlendDetails.styled'
import { CardTitle } from '../../../../../components'
import { TBins } from '../../../../../types'

type SavedBlendRatioTypes = {
  selectedBins?: TBins[]
}

export const SavedBlendRatio = ({ selectedBins }: SavedBlendRatioTypes) => {
  return (
    <BlendRatioContainer>
      <CardTitle title="Ratio" />
      <BlendRatioItems>
        {selectedBins?.map((bin) => {
          return (
            <BlendRatioItem key={bin.id}>
              <span>{bin.value}%</span>
              <span>{bin.bin_name}</span>
            </BlendRatioItem>
          )
        })}
      </BlendRatioItems>
    </BlendRatioContainer>
  )
}
